var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-flex",class:_vm.topClasses,style:({ height: _vm.height })},[_c('div',{staticClass:"top-fixed"},[_vm._t("top")],2),_c('div',{staticClass:"bottom-content-wrapper"},[_vm._t("bottom")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }